import { combineReducers } from 'lib/misc';
import { touchEntity, touchDetectedEntity } from './touchEntity';

export { stabilizers } from './stabilizer';
export { MainAction } from './MainAction';
export { MainSelector } from './MainSelector';

export type State = {
  touch?: boolean;
  touchDetected?: boolean;
};

export const reducer = combineReducers<State>({
  touch: touchEntity.reducer,
  touchDetected: touchDetectedEntity.reducer,
});



// WEBPACK FOOTER //
// ./src/module/Redux/Main/index.tsx